import { axios } from './base-api'

const getJobBoardOffers = async(dataEndpoint) => {
  const response = await fetch(dataEndpoint);
  const data = await response.json();
  return data;
}

export {
  getJobBoardOffers
}